import Keycloak from 'keycloak-js';
import type { RuntimeConfig } from '../config';

/**
 * Connexion par redirection vers Keycloak (Authorization Code + PKCE).
 * L'interface ne voit jamais de mot de passe ; elle reçoit un jeton d'accès court
 * qu'elle rafraîchit silencieusement avant chaque appel.
 */
let instance: Keycloak | null = null;
let initialised: Promise<boolean> | null = null;

export function keycloak(): Keycloak {
  if (!instance) throw new Error('Keycloak non initialisé');
  return instance;
}

/** Initialisation unique (React StrictMode monte deux fois en dev). */
export function initKeycloak(config: RuntimeConfig): Promise<boolean> {
  if (!initialised) {
    instance = new Keycloak({ url: config.keycloakUrl, realm: config.realm, clientId: config.clientId });
    initialised = instance.init({
      onLoad: 'check-sso',
      pkceMethod: 'S256',
      silentCheckSsoRedirectUri: `${location.origin}/silent-check-sso.html`,
      checkLoginIframe: false,
    });
  }
  return initialised;
}

export function isAuthenticated(): boolean {
  return instance?.authenticated ?? false;
}

export async function getAccessToken(): Promise<string | null> {
  const kc = keycloak();
  if (!kc.authenticated) return null;
  try {
    await kc.updateToken(30);
  } catch {
    await kc.login();
    return null;
  }
  return kc.token ?? null;
}

export function login(): Promise<void> {
  return keycloak().login({ redirectUri: `${location.origin}/start` });
}

export function logout(): Promise<void> {
  return keycloak().logout({ redirectUri: location.origin });
}
